import Vue from 'vue'
import Vuex from 'vuex'
import { FeathersVuex as ApiFeathersVuex } from '@/api'
import { FeathersVuex as BotFeathersVuex } from '@/bot'

// vuex modules
import { app } from './modules/app'
import { config } from './modules/config'
import { content } from './modules/content'
import { emoji } from './modules/emoji'
import { apiAuth, botAuth } from './store-auth'

Vue.use(Vuex)
Vue.use(ApiFeathersVuex)
Vue.use(BotFeathersVuex)

const requireModule = require.context(
  // The path where the service modules live
  './services',
  // Whether to look in subfolders
  false,
  // Only include .js files (prevents duplicate imports`)
  /.js$/
)

const servicePlugins = requireModule
  .keys()
  .map(modulePath => requireModule(modulePath).default)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  plugins: [...servicePlugins, apiAuth, botAuth],
  modules: {
    app,
    config,
    content,
    emoji
  }
})
